import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import {FormLocationsTable} from 'shells/forms/form-locations-table';

import type {
    GetFormLocations as GetFormLocationsQuery,
    GetFormLocationsVariables as GetFormLocationsQueryVariables,
} from 'nutshell-graphql-types';

import GET_FORM_LOCATIONS from '../../graphql/queries/get-form-locations.graphql';

type Props = {
    formId: string;
    linkHeaderTitle: string;
    showStats: boolean;
};

FormLocationsTableContainer.defaultProps = {
    linkHeaderTitle: 'URL',
};

export function FormLocationsTableContainer(props: Props) {
    const {data, loading} = useQuery<GetFormLocationsQuery, GetFormLocationsQueryVariables>(
        GET_FORM_LOCATIONS,
        {
            variables: {formId: props.formId},
            notifyOnNetworkStatusChange: true,
        }
    );

    const form = data ? data.form : null;

    return (
        <FormLocationsTable
            data={
                form && form.locations
                    ? form.locations.map((location) => {
                          return {
                              url: location.url,
                              lastSubmissionDate: location.lastSubmissionDate,
                              submissionsCount: location.submissionsCount,
                              conversionRate: location.conversionRate,
                          };
                      })
                    : []
            }
            isLoading={loading}
            linkHeaderTitle={props.linkHeaderTitle}
            includeStats={props.showStats}
        />
    );
}
